import _ from 'lodash';
import React, { Component } from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import PrivacyBlock from 'components/core/docs/privacy/Privacy';
import TermsBlock from 'components/core/docs/terms/Terms';
import FooterDialog from './components/FooterDialog';
import Socials from './Socials';
import Logo from './Logo';
import FooterLinks from './FooterLinks';

import './Footer.css';

const dumbFooter = dumbBem('l-footer');
const FooterWrp = tx(dumbFooter)('div');

const Links = tx([{ element: 'links' }, dumbFooter])('div');
const Info = tx([{ element: 'info' }, dumbFooter])('div');
const Group = tx([{ element: 'group' }, dumbFooter])('div');
const Rights = tx([{ element: 'rights' }, dumbFooter])('div');

const getTitleAndContent = blockName => {
  let dialogContent;
  let dialogTitle;

  switch (blockName) {
    case 'terms':
      dialogTitle = TermsBlock.title();
      dialogContent = <TermsBlock />;
      break;
    case 'privacy':
      dialogTitle = PrivacyBlock.title();
      dialogContent = <PrivacyBlock />;
      break;
    default:
      break;
  }

  return { dialogTitle, dialogContent };
};

export class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerDialogOpen: false,
      dialogTitle: null,
      dialogContent: null,
    };

    _.bindAll(this, ['handleFooterDialogOpen', 'handleFooterDialogClose']);
  }

  handleFooterDialogOpen(type) {
    const { dialogTitle, dialogContent } = getTitleAndContent(type);
    this.setState({ footerDialogOpen: true, dialogTitle, dialogContent });
  }

  handleFooterDialogClose() {
    this.setState({ footerDialogOpen: false });
  }

  render() {
    const { footerDialogOpen, dialogTitle, dialogContent } = this.state;

    return (
      <FooterWrp>
        <Links>
          <Logo />

          <Group>
            <Socials />
          </Group>
        </Links>

        <Info>
          <FooterLinks handleClick={this.handleFooterDialogOpen} />

          <Rights>© 2018 Iterio, Inc. All rights reserved.</Rights>
        </Info>

        <FooterDialog
          open={footerDialogOpen}
          title={dialogTitle}
          content={dialogContent}
          handleClose={this.handleFooterDialogClose}
        />
      </FooterWrp>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/Footer.jsx